import {
  getAttributeValues as _getAttributeValues,
  getFirstAttributeValue as _getFirstAttributeValue
} from "@scayle/storefront-api";
export const getFirstAttributeValue = (attributes, attributeName) => {
  return _getFirstAttributeValue(attributes, attributeName);
};
export const getAttributeValue = (attributes, attributeName) => {
  const values = getFirstAttributeValue(attributes, attributeName);
  return values?.value ?? values?.label;
};
export const getAttributeValueTuples = (attributes, attributeName) => {
  return _getAttributeValues(attributes, attributeName);
};
export const getManyAttributeValueTuples = (attributes, attributeNames) => {
  return attributeNames.map((key) => getFirstAttributeValue(attributes, key)).filter((entry) => !!entry);
};
